<template>
  <div>
    <Banner />
    <EarthWaring />
    <Bingchuan />
    <Believe />
    <Green />
    <Earth />
    <!-- <Bottom /> -->
    <Footer />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { url } from '@zz-common/zz-utils'
import Banner from '@/components/Banner.vue'
import Earth from '@/components/Earth.vue'
import EarthWaring from '@/components/EarthWaring.vue'
import Believe from '@/components/Believe.vue'
import Bingchuan from '@/components/Bingchuan.vue'
import Green from '@/components/Green.vue'
// import Bottom from '@/components/Bottom.vue'
import Footer from '@/components/Footer.vue'

let lang = url.getParam('lang') || ''

export default Vue.extend({
  name: 'container-view',
  components: {
    Banner,
    Earth,
    Believe,
    Bingchuan,
    EarthWaring,
    Green,
    // Bottom,
    Footer
  },

  created() {
    // lang如果是en，就设置为en，其它情况设置为zh-cn
    lang = lang.includes('en') ? 'en' : 'zh-cn'
    this.$store.commit('switchLang', lang)

    // 如果页面分辨率大于1280，则给html设置overflow-x: hidden
    if (window.innerWidth > 1200) {
      document.documentElement.style.overflowX = 'hidden'
    }

    if (lang === 'en') {
      document.title = 'Save money. Save the world.'
    } else {
      document.title = '二手拯救世界'
    }
  }
})
</script>
